module.exports = __webpack_public_path__ + "static/media/dot.df4420f8.svg";